import { Fragment, h } from "preact";
import { observer } from "mobx-react";
import { t, translate } from "../I18n";
import TextField from "./TextField";
import Alert from "./Alert";
import SelectField from "./SelectField";
import CheckboxField from "./CheckboxField";
import DeliveryAddressDivider from "./DeliveryAddressDivider";
import DeliveryFormItemWrapper from "./DeliveryFormItemWrapper";
import StreetAddressForm from "./StreetAddressForm";
import LocateMeButton from "./LocateMeButton";
function DeliveryAddressForm(props) {
    const { controller, withApartmentInfo, withNoContactDelivery, isPostCodeRequired, status, } = props;
    const { noContactDelivery } = controller.fields;
    const { streetAddressController, apartmentInfoController } = controller;
    const showLocateMeButton = !((window.Skubacz.Device.isMobileApp() &&
        !window.Skubacz.Device.mobileGeolocationEnabled()) ||
        window.Skubacz.Device.isInIframe());
    return (h("div", { class: "u-mt2" },
        showLocateMeButton && (h(LocateMeButton, { onLocateMe: () => streetAddressController.locateMe() })),
        h("div", { class: "m-delivery-address__container" },
            h(StreetAddressForm, { controller: streetAddressController, isPostCodeRequired: isPostCodeRequired }),
            withApartmentInfo && (h(Fragment, null,
                h(DeliveryAddressDivider, null),
                h(ApartmentInfoForm, { controller: apartmentInfoController })))),
        withNoContactDelivery && h(NoContactDelivery, { field: noContactDelivery }),
        h("div", { class: "m-delivery-address__status" },
            h(AddressStatus, { status: status, showEmptyMessage: !withApartmentInfo }))));
}
function ApartmentInfoForm(props) {
    const { controller } = props;
    switch (controller.type) {
        case "Default":
            return h(DefaultApartmentInfo, { controller: controller });
        case "Romanian":
            return h(RomanianApartmentInfo, { controller: controller });
    }
}
function DefaultApartmentInfo(props) {
    const { controller } = props;
    const { fields } = controller;
    return (h(Fragment, null,
        h(DeliveryFormItemWrapper, { name: "apt-number" },
            h(TextField, { name: "apt-number", dataFieldId: "fulfillmentMethod.deliveryAddress.aptNumber", label: translate(t.activerecord.attributes.delivery_address.apt_number), controller: fields.aptNumber, required: false })),
        h(DeliveryFormItemWrapper, { name: "floor" },
            h(TextField, { name: "floor", dataFieldId: "fulfillmentMethod.deliveryAddress.floor", label: translate(t.activerecord.attributes.delivery_address.floor), controller: fields.floor, required: false }))));
}
const RomanianApartmentInfo = observer((props) => {
    const { controller } = props;
    const { fields } = controller;
    const houseOrBlockOptions = [
        {
            value: "House",
            label: translate(t.formtastic.labels.delivery_address.house),
        },
        {
            value: "Block",
            label: translate(t.formtastic.labels.delivery_address.block),
        },
    ];
    const isBlockAptInfo = fields.houseOrBlock.value === "Block";
    return (h(Fragment, null,
        h(DeliveryFormItemWrapper, { name: "sector" },
            h(TextField, { name: "sector", dataFieldId: "fulfillmentMethod.deliveryAddress.sector", label: translate(t.formtastic.labels.delivery_address.sector), controller: fields.sector, required: false })),
        h(DeliveryAddressDivider, null),
        h(DeliveryFormItemWrapper, { name: "house_or_block" },
            h(SelectField, { name: "house_or_block", dataFieldId: "fulfillmentMethod.deliveryAddress.houseOrBlock", label: translate(t.formtastic.labels.delivery_address.house_or_block), controller: fields.houseOrBlock, options: houseOrBlockOptions })),
        isBlockAptInfo && (h(Fragment, null,
            h(DeliveryAddressDivider, null),
            h(DeliveryFormItemWrapper, { name: "block" },
                h(TextField, { name: "block", dataFieldId: "fulfillmentMethod.deliveryAddress.block", label: translate(t.formtastic.labels.delivery_address.block), controller: fields.block, required: true })),
            h(DeliveryFormItemWrapper, { name: "staircase" },
                h(TextField, { name: "staircase", dataFieldId: "fulfillmentMethod.deliveryAddress.staircase", label: translate(t.formtastic.labels.delivery_address.staircase), controller: fields.staircase, required: true })),
            h(DeliveryAddressDivider, null),
            h(DeliveryFormItemWrapper, { name: "floor" },
                h(TextField, { name: "floor", dataFieldId: "fulfillmentMethod.deliveryAddress.floor", label: translate(t.activerecord.attributes.delivery_address.floor), controller: fields.floor, required: true })),
            h(DeliveryFormItemWrapper, { name: "apt-number" },
                h(TextField, { name: "apt-number", dataFieldId: "fulfillmentMethod.deliveryAddress.aptNumber", label: translate(t.formtastic.labels.delivery_address.apt_number), controller: fields.aptNumber, required: true })),
            h(DeliveryAddressDivider, null),
            h(DeliveryFormItemWrapper, { name: "interphone" },
                h(TextField, { name: "interphone", dataFieldId: "fulfillmentMethod.deliveryAddress.interphone", label: translate(t.formtastic.labels.delivery_address.interphone), controller: fields.interphone, required: false })))),
        h(DeliveryAddressDivider, null),
        h(DeliveryFormItemWrapper, { name: "additionalInfo" },
            h(TextField, { name: "additionalInfo", dataFieldId: "fulfillmentMethod.deliveryAddress.additionalInfo", label: translate(t.formtastic.labels.delivery_address.additional_info), controller: fields.additionalInfo, required: false }))));
});
function NoContactDelivery(props) {
    const { field } = props;
    return (h("div", { class: "form-group" },
        h(CheckboxField, { name: "noContactDelivery", dataFieldId: "fulfillmentMethod.deliveryAddress.noContactDelivery", label: translate(t.delivery_method.no_contact_delivery_choice), helpText: translate(t.delivery_method.no_contact_delivery_tooltip), controller: field, required: false })));
}
function AddressStatus(props) {
    const { status, showLoading = true, showEmptyMessage = true } = props;
    switch (status.type) {
        case "NotRequested":
        case "NoAddressProvided":
            return showEmptyMessage ? (h(Alert, { type: "info", icon: "info-sign", message: translate(t.delivery.enter_address) })) : null;
        case "Loading":
            return showLoading ? (h("div", null,
                h("i", { class: "icon-spinner icon-spin u-mr2", "aria-hidden": "true" }),
                translate(t.delivery.geocoding))) : null;
        case "AddressDoesNotExistOrInaccurate":
            return (h(Alert, { type: "danger", message: translate(t.delivery.geocoding_error) }));
        default:
            return null;
    }
}
export default observer(DeliveryAddressForm);
